import { useEffect } from 'react';

const useIntersectionAnimate = (
  selector: string,
  animateClass: string,
  options: IntersectionObserverInit = { threshold: 1 }
) => {
  useEffect(() => {
    const elements = document.querySelectorAll(selector);

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle(animateClass, entry.isIntersecting);
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
        }
        // console.log(`entry`, entry, observer);
      });
    }, options);

    elements.forEach((el) => observer.observe(el));

    return () => {
      observer.disconnect();
    };
  }, [selector, animateClass, options]);
};

export default useIntersectionAnimate;
